import { MdAttachMoney, MdFormatColorFill, MdLaunch, MdOutlineImage, MdOutlineTextFields } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { IPlaceholderType } from '~/types/template'

interface Props {
  type: IPlaceholderType | IPlaceholderType[]
}

const PlaceholderTypeIcon = ({ type }: Props): ReactElement => {
  const types = Array.isArray(type) ? type : [type]
  return (
    <div className="placeholder-type-icons">
      {types.map((t, index) => {
        switch (t) {
          case 'translation':
            return <MdOutlineTextFields key={index} />
          case 'asset':
            return <MdOutlineImage key={index} />
          case 'iap':
            return <MdAttachMoney key={index} />
          case 'action':
            return <MdLaunch key={index} />
          case 'color':
            return <MdFormatColorFill key={index} />
          default:
            return undefined
        }
      })}
    </div>
  )
}

export default PlaceholderTypeIcon
